// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n#border[data-v-1f7971d2] {\n}\n", "",{"version":3,"sources":["webpack://components/components/BorderedListItem.vue"],"names":[],"mappings":";AAOA;AAEA","sourcesContent":["<template>\n  <div id=\"border\">\n\n  </div>\n</template>\n\n<style scoped>\n#border {\n\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
